import { QueryCache, QueryClient } from '@tanstack/react-query';

import * as Sentry from '@sentry/react';

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      Sentry.captureException(error);
      // toast.error('Something went wrong. Please try again.');
    },
  }),
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});

export default queryClient;
